var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M206.78-60.78q-44.3 0-75.15-30.85-30.85-30.85-30.85-75.15v-546.44q0-44.3 30.85-75.15 30.85-30.85 75.15-30.85H240v-80h93v80h294v-80h93v80h33.22q44.3 0 75.15 30.85 30.85 30.85 30.85 75.15v546.44q0 44.3-30.85 75.15-30.85 30.85-75.15 30.85H206.78Zm0-106h546.44V-560H206.78v393.22Zm0-473.22h546.44v-73.22H206.78V-640Zm0 0v-73.22V-640Z"}));
}

Calendar.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = Calendar;

Calendar.default = Calendar;
